import { ScopeConfiguration, ScopeVersion } from '@core/model/scope-version'

import { ComponentModifier } from '@app/features/company-management/models/component-modifier.model'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { KeyValue } from '@app/core/types/key-value.type'
import { environment } from '@envs/environment'
import { map } from 'rxjs'
import { plainToInstance } from 'class-transformer'

@Injectable({ providedIn: 'root' })
export class ScopeConfigurationService {
  private readonly BASE_API_URL: string = environment.scopeApiUrl

  constructor(private http: HttpClient) {}

  saveConfiguration(scopeId: number, configuration: ScopeConfiguration) {
    return this.http.post<any>(`${this.BASE_API_URL}scope/${scopeId}/configuration`, configuration)
  }

  getModifiers(scenarioId: number) {
    return this.http
      .get<ComponentModifier[]>(`${this.BASE_API_URL}scenarios/${scenarioId}/component-formulas`)
      .pipe(map((api) => plainToInstance(ComponentModifier, api)))
  }

  submitConfiguration(scopeId: number, modifierResults: KeyValue) {
    return this.http
      .post<ScopeVersion>(`${this.BASE_API_URL}scope/${scopeId}/submit-configuration`, modifierResults)
      .pipe(map((api) => plainToInstance(ScopeVersion, api)))
  }
}
